import { z } from 'zod';

export interface CustomerView {
  id: string;
  misoCustomerId: string;
  phone: string;
}

// ============================================================================
// Zod Schemas
// ============================================================================

/**
 * CustomerView 스키마
 */
export const customerViewSchema = z.object({
  id: z.string(),
  misoCustomerId: z.string(),
  phone: z.string(),
});

// ============================================================================
// Type Inference from Schemas
// ============================================================================

export type CustomerViewInput = z.infer<typeof customerViewSchema>;
